<template>
  <div>
    <q-dialog v-if="identificacaoFiscal" v-model="modalLogin" persistent>
      <q-card style="width: 700px; max-width: 80vw;">
        <q-card-section>
          <div class="text-h6">Confirmação para Login</div>
        </q-card-section>
        <q-card-section class="q-pt-none">
          Digite o código recebido via e-mail ou telefone para prosseguir.<br />Você receberá o codigo caso os dados
          informados previamente estejam corretos.
        </q-card-section>
        <q-card-section class="q-pt-none">
          <div class="row q-gutter-lg q-pr-md q-pb-md">
            <div class="col-xs-12 col-sm-12 col-md-4">
              <q-input label="Código recebido*" v-model="codigoVerificador" outlined :dense="true" lazy-rules
                :rules="[val => val && val.length > 0 || 'Campo obrigatório']" />
            </div>
            <div class="col-xs-12 col-sm-12 col-md-2">
              <q-btn :loading="loadingConfirmarCodigo" color="primary" label="Confirmar"
                @click="confirmarCodigoVerificador" />
            </div>
          </div>
        </q-card-section>

        <q-card-actions align="right" class="bg-white text-teal">
          <q-btn flat label="Fechar" @click="closeModalLogin" />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import AuthService from '@/services/auth'
export default {
  data () {
    return {
      codigoVerificador: null,
      loadingConfirmarCodigo: false
    }
  },
  props: ['identificacaoFiscal', 'modalLogin'],
  methods: {
    confirmarCodigoVerificador () {
      AuthService.login(this.identificacaoFiscal, this.codigoVerificador).then(() => {
        this.loadingConfirmarCodigo = false
        this.$router.push({ name: 'DadosBeneficiario' })
      }).catch((e) => {
        this.loadingConfirmarCodigo = false
        return this.$b.nWarning('Codigo verificador inválido')
      })
    },
    closeModalLogin () {
      this.identificacaoFiscal = null
      window.location.reload()
    }
  }
}

</script>
